
module.config(function($stateProvider) {
    $stateProvider.state("student.placements", {
        abstract: true,
        url: '/placements',
        templateUrl: 'empty',
        permissions: 'viewPlacements',
        resolve: {
            auth: function($checkPermissions, student, permissions) {
                if (student.has_enrollment || student.placements > 0) {
                    return true;
                }
                return $checkPermissions('administerStudents', permissions);
            },
        }
    })

    .state('placementIndex', {
        parent: 'student.placements',
        url: '',
        templateUrl: 'students/placements/index',
        controller: 'PlacementIndexController',
        resolve: {
            educationPlacements: function(student, ModelService) {
                return ModelService.index('education_placement', {
                    participant_id: student.id,
                    no_page: true});
            },

            jobPlacements: function(student, ModelService) {
                return ModelService.index('job_placement', {
                    participant_id: student.id,
                    no_page: true});
            },
        }
    })

    .state('jobPlacement', {
        parent: 'student.placements',
        templateUrl: 'students/placements/viewJob',
        url: '/job/{job_id:int}',
        resolve: {
            placement: function($stateParams, student, ModelService) {
                return ModelService.get('job_placement', $stateParams.job_id)
                    .then(ModelService.assertRelation('participant_id', student.id));
            },
        },
        controller: 'JobPlacementController'
    })

    .state('educationPlacement', {
        parent: 'student.placements',
        templateUrl: 'students/placements/viewEducation',
        url: '/edu/{education_id:int}',
        resolve: {
            placement: function($stateParams, $q, student, ModelService) {
                return ModelService.get('education_placement', $stateParams.education_id)
                    .then(ModelService.assertRelation('participant_id', student.id));
            },
        },
        controller: module.cC({
            inject: ['$scope', '$state', 'placement', 'ModelService'],

            data: {
                fieldDegrees: "['bachelors', 'associates', 'graduate']",
                credentials: "['technical', 'apprenticeship', 'other']",
                placement: 'placement'
            },

            watch: {
                'placement.institution_type': '_setIsCollege',
            },

            methods: {
                deletePlacement: function() {
                    this.ModelService.deleteModel(this.placement)
                        .then(this.$state.go.bind(this.$state,
                                                  'placementIndex'));
                },
                _setIsCollege: function(t) {
                    console.log(t);
                    this.$.isCollege = t == 'college' || t == "community_college";
                }
            },
        }),
    });
});
